import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "./reports.css"
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { BarLoader, ClipLoader } from 'react-spinners';
import { useCurrency } from '../../Layouts/currencyContext';
import { LiaFileExcel } from "react-icons/lia";
import * as XLSX from "xlsx";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

const GrnReports = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [dateFilter, setdateFilter] = useState(true);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [SupplierList, setSuppliers] = useState([]);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const [itemOptions, setItemOptions] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoaders] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const { currencyPrecision } = useCurrency();
    const apiService = new ApiService();

    const [precision, setPrecision] = useState(currencyPrecision?.exp1 || 3);

    const StatusFilter = [
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Aproved' },
        { value: '2', label: 'Hold' },
        { value: '3', label: 'Rejected' },
    ];
    const gridRef = useRef();
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    const [formData, setFormData] = useState({
        email: "",
        withoutPo: false,
        StockType: [{ label: 'Select Stock Type', value: '0' }],
        Status: [{ label: 'Filter By', value: '' }],
        GrnNo: '',
        PONo: '',
        fromDate: '',          // Today's date
        toDate: '',
        itemNo: [{ label: 'Item No', value: '' }],
        ItemDescription: [{ label: 'Item Description', value: '' }],
        costcenter: '',
        SupplierName: [{ label: 'Select Supplier', value: '' }],
        SupplierId: [{ label: 'Select Supplier Id', value: '' }],
    });
    const handleClearFilters = () => {
        const today = new Date();
        setFormData({
            email: "",
            withoutPo: false,
            StockType: [{ label: 'Select Stock Type', value: '0' }],
            Status: [{ label: 'Filter By', value: '' }],
            GrnNo: '',
            PONo: '',
            fromDate: formatDate(today),
            toDate: formatDate(today),
            itemNo: [{ label: 'Item No', value: '' }],
            ItemDescription: [{ label: 'Item Description', value: '' }],
            costcenter: '',
            SupplierName: [{ label: 'Select Supplier', value: '' }],
            SupplierId: [{ label: 'Select Supplier Id', value: '' }],
        });
        setdateFilter(false)
    };
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const apiService = new ApiService();
                let param = `?isActive=true`
                let Currencyres = await apiService.get('GET_CURRENCY_MASTER')
                const filteredDenominations = Currencyres?.data?.result?.find(currency => currency?.isDefault === true);
                setPrecision(filteredDenominations?.precision)
                const suppliers = await apiService.get('GET_SUPPLIER');
                setSuppliers(suppliers?.data?.result);
                const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
                setStockType(stockType?.data?.result);
                // getItems()
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
    }, []);

    useEffect(() => {

        const today = new Date();

        setFormData((prev) => ({
            ...prev,
            fromDate: formatDate(today),
            toDate: formatDate(today),
        }));
    }, []);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);

    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoaders(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');

            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);

            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoaders(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoaders(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue?.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue?.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const handleSupplierChange = (selectedOption) => {
        setFormData({ ...formData, SupplierName: selectedOption });
    }
    const handleSupplierIdChange = (selectedOption) => {
        setFormData({
            ...formData,
            SupplierId: { value: selectedOption.value, label: selectedOption.label },
            SupplierName: { value: selectedOption.value, label: selectedOption.value?.supplierName }
        });
    }

    const handleSearch = async () => {
        setSearchLoader(true);
        await getItems(1);
        setSearchLoader(false);
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {

            setSearchLoader(true);
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('GRNNo', formData.GrnNo || "");
            params.append('Status', formData.Status.value || "");
            params.append('ItemDescription', formData.ItemDescription.label || "");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
            params.append('POrderNo', formData.PONo || "");
            params.append('VendorId', formData.SupplierId?.label || "");
            params.append('VendorName', formData.SupplierName?.label || "");
            params.append('CostCenter3', formData.costcenter || "");
            params.append('ItemNo', formData.ItemNo?.label || "");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            if (dateFilter === true) {
                params.append('FromDate', formData?.fromDate || "");
                params.append('ToDate', formData?.toDate || "");
            }
            const res = await apiService.getApiParamater('GET_GRN_REPORT', `?${params.toString()}`);
            setRowData(res?.data?.result || [])
            setPagination(res.data.paginationData);
            setSearchLoader(false);
            setFormData((prev) => ({
                ...prev,
                fromDate: formData.fromDate,
                toDate: formData.toDate,
            }));
        } catch (error) {
            console.error('Error fetching items:', error);
            setSearchLoader(false);
        }
    }
    const Comparison = [
        { headerName: 'GRN No', field: 'grnNo', suppressMovable: true, width: 140 },
        {
            headerName: 'Invoice Date', field: 'invoiceDate', suppressMovable: true, width: 140, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Invoice No', field: 'invoiceNo', suppressMovable: true, width: 130 },
        { headerName: 'Invoice Ref', field: 'invoiceRef', suppressMovable: true, width: 130 },
        {
            headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 140,
        },
        { headerName: 'Vendor Name', field: 'vendorName', suppressMovable: true, width: 170 },
        {
            headerName: 'Delivery Date', field: 'delivery_Date', suppressMovable: true, width: 140, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Currency Code', field: 'currencyCode', suppressMovable: true, width: 150 },
        { headerName: 'Exchange Rate', field: 'exchangeRate', suppressMovable: true, width: 150 },
        {
            headerName: 'Amount', field: 'amount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 3)
        },
        {
            headerName: 'Status', field: 'status', suppressMovable: true, width: 180,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<button class="btn pend ">Pending</button>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<button class="btn aproved">Approved</button>);
                }
                else if (params.value === 2 || params.value === null) {
                    return (<button class="btn hold">Hold</button>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<button class="btn reject">Rejected</button>);
                } else {
                    return params.value;
                }
            }
        },
    ];
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'GrnReport.csv'
        });
    }, []);
    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = [
            'recordId',
            'requestor',
            'requisitionDate',
            'costCenter1',
            'status',
            'itemCode',
            'itemDescription',
            'uom',
            'qty',
        ];
        const translateStatus = (status) => {
            switch (status) {
                case 1:
                    return 'Approved';
                case 0:
                    return 'Pending';
                case 2:
                    return 'Hold';
                case 3:
                    return 'Rejected';
                default:
                    return status;
            }
        };

        comparisonFields.forEach(field => {
            const header = Comparison.find(col => col.field === field).headerName;
            columnHeaders.push(header);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                let value = node.data[field];
                if (field === 'status') {
                    value = translateStatus(value);
                }
                row.push(value);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Purchase Requsition Report", 65, 12);
        doc.text("__________________________", 60, 15);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 6,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 6,
            },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 20 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20 },
                4: { cellWidth: 15 },
                5: { cellWidth: 20 },
                6: { cellWidth: 20 },
                7: { cellWidth: 15 },
                8: { cellWidth: 20 },
            },
            startY: 20
        });

        doc.save('GrnReport.pdf');
    }, []);
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handleStatusFilter = (selectedOption) => {
        setFormData({ ...formData, Status: selectedOption });
    }
    const handleItemChange = (selectedOption) => {
        setFormData({
            ...formData,
            itemNo: selectedOption ? { label: selectedOption.value.itemNo, value: selectedOption.value } : null,
            ItemDescription: selectedOption ? { label: selectedOption.value.itemDescription, value: selectedOption.value } : null,
        });
    }
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            const params = new URLSearchParams();
            params.append('GRNNo', formdata.GrnNo || "");
            params.append('Status', formdata.Status.value || "");
            params.append('ItemDescription', formdata.ItemDescription.label || "");
            params.append('StockType', formdata.StockType?.value?.stockTypeCode || "");
            params.append('POrderNo', formdata.PONo || "");
            params.append('VendorId', formdata.SupplierId?.label || "");
            params.append('VendorName', formdata.SupplierName?.label || "");
            params.append('CostCenter3', formdata.costcenter || "");
            params.append('ItemNo', formdata.ItemNo?.label || "");
            params.append('PageNo', 1);
            params.append('PageSize', pagedata?.totalRecords || 10000);
            params.append('FromDate', formdata?.fromDate || "");
            params.append('ToDate', formdata?.toDate || "");
            const res = await apiService.getApiParamater('GET_GRN_REPORT', `?${params.toString()}`);
            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                setLoading(false);
                return;
            }

            const totalAmount = allData.reduce((sum, item) => sum + (item.amount || 0), 0);


            const excelData = allData.map((item) => ({
                "GRN No": item.grnNo,
                "Invoice Date": moment(item.invoiceDate).format("DD-MMM-YY"),
                "Invoice No": item.invoiceNo,
                "Ref": item.invoiceRef,
                "PO Number": item.pOrderNo,
                "Vendor": item.vendorName,
                "Delivery Date": moment(item.delivery_Date).format("DD-MMM-YY"),
                "Curr Code": item.currencyCode,
                "Exchange Rate": item.exchangeRate,
                "Amount": Number(item.amount || 0).toFixed(precision || 3),
                "Status": item.status === 1 ? "Approved" : item.status === 0 ? "Pending" : item.status === 5 ? "Hold" : "Rejected",
            }));

            excelData.push({}); // Add an empty row for spacing

            const totalRow = {
                "GRN No": "",
                "Invoice Date": "",
                "Invoice No": "",
                "Ref": "",
                "PO Number": "",
                "Vendor": "",
                "Delivery Date": "",
                "Curr Code": "",
                "Exchange Rate": "Total",
                "Amount": Number(totalAmount || 0).toFixed(precision || 3),
                "Status": "",
            };
            excelData.push(totalRow);

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // Auto-fit column widths
            const columnWidths = Object.keys(excelData[0]).map((header) => {
                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) =>
                        row[header] ? row[header].toString().length : 0
                    )
                );

                return {
                    wch: maxLength,
                };
            });

            worksheet["!cols"] = columnWidths;

            // Style for the total row
            const totalRowStyle = {
                font: { bold: true },
                fill: { fgColor: { rgb: "E0E0E0" } } // Light Grey
            };

            // Get the range of the worksheet
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            const totalRowIndex = excelData.length; // 0-indexed row in the sheet data (excluding header)

            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: C });
                if (worksheet[cellAddress]) worksheet[cellAddress].s = totalRowStyle;
            }

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "GRN Report");

            XLSX.writeFile(workbook, "GRNReport.xlsx");

            toast.success("GRNReport.xlsx downloaded");
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    }, [precision]);
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }

    const handleShow = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'GRNSummary' },
                    { name: 'FromDate', value: formData?.fromDate || '' },
                    { name: 'toDate', value: formData?.toDate || '' },
                    { name: 'VendorName', value: formData.SupplierName?.label || '' },
                    { name: 'GRNNo', value: formData.GrnNo || '' },
                ];

                debugger
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row' >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.SupplierId}
                                onChange={(selectedOption) => handleSupplierIdChange(selectedOption)}
                                options={SupplierList?.map((supl) => ({ value: supl, label: supl?.record_Id }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.SupplierName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleStockChange(selectedOption)}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={handleStatusFilter}
                            />
                        </div>
                    </div>
                    <div className='row my-2'>
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                value={formData.GrnNo}
                                name="GrnNo"
                                onChange={handleInputChange}
                                placeholder='Enter Grn number'
                            />
                        </div>
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                value={formData.PONo}
                                name="PONo"
                                onChange={handleInputChange}
                                placeholder='Enter PO number'
                            />
                        </div>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.itemNo}
                                options={itemOptions}
                                loadOptions={loadOptions}
                                onChange={selectedOption => handleItemChange(selectedOption)}
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                        </div>
                        <div className='col'>
                            <AsyncSelect
                                cacheOptions
                                value={formData.ItemDescription}
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={selectedOption => handleItemChange(selectedOption)}
                                className="w-100 p-0"
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                                noOptionsMessage={({ inputValue }) =>
                                    inputValue.length < 3
                                        ? "Type at least 3 characters..."
                                        : "No records found"
                                }
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                id="validationCustom02"
                                value={formData.costcenter}
                                name="costcenter"
                                onChange={handleInputChange}
                                placeholder='cost center 3'
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.fromDate}
                                // disabled={!dateFilter}
                                onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                className="p-2 form-Input w-100"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.toDate}
                                onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                className="p-2 form-Input w-100"
                                // disabled={!dateFilter}

                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        {/* <div className='col gap-2 center'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div> */}
                    </div>
                </div>
                <div className='col-3 '>
                    {searchLoader === true ?
                        <button className='mainbtnGry w-100' type="button"><ClipLoader color="#ffffff" size={25} /></button> :
                        <div onClick={handleSearch} className='mainbtnGry flex-end gap-2'>
                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Search</div>
                        </div>
                    }
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >GRN Report</div>
                <div className='d-flex gap-3 end'>
                    <div onClick={handleShow} className='mainbtnGry flex-end gap-2'>
                        <div className='center'>Show</div>
                    </div>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            columnDefs={Comparison}
                            ref={gridRef}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
        </div>
    );
};
export default GrnReports;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};